<template>
  <div class="notice-new">
    <p>シッター作成</p>
		<div class="notice-table">
			<b-form @submit.prevent="sitterCreateProc">
				<b-form-group
					id="input-group-1"
					label="名前"
					label-for="input-1">
					<b-form-input
						id="input-1"
						v-model="form.name"
						type="text"
						required
						placeholder="">
					</b-form-input>
				</b-form-group>
				<b-form-group
					id="textarea-rows"
					label="メールアドレス"
					label-for="textarea-rows">
					<b-form-input
						id="textarea-rows"
						placeholder=""
            type="email"
						v-model="form.email"
					></b-form-input>
				</b-form-group>
				<p class="notice-create-btn">
					<b-button type="submit">新規</b-button>
				</p>
			</b-form>
		</div>
    <Loading v-if="isLoading" />
  </div>
</template>
<script>
import Loading from '@/components/main/Loading'
import apiClient from '../../backend'

export default {
  methods: {
  },
  data () {
    return {
			form: {
				name: '',
				email: ''
			},
			isLoading: false
    }
  },
  components: {
    Loading
  },
  mounted () {
  },
  methods: {
		sitterCreateProc() {
			var self = this
			this.$modal.show('dialog', {
        title: 'シッター作成',
        text: `${this.form.name} / ${this.form.email}`,
        buttons: [
          {
            title: 'はい',
            handler: () => {
							self.isLoading = true
							apiClient.createSitter(this.form).then(response => {
								console.log(response)
								self.isLoading = false
								if (response.error) {
									alert(response.error)
									return
								}
								this.$router.go(-1)
							}).catch(error => {
								self.isLoading = false
							})
            }
          },
          {
            title: 'キャンセル'
          }
        ]
      })
		}
  },
}
</script>
